import { IsEmail, IsEnum, IsMobilePhone, IsOptional, Length, Matches } from 'class-validator';

import { AddressTypeEnum } from '@onArte/shared/database';
import { phoneRegexp } from '@onArte/shared/regexp';

export class AddressSaveModel {
  @IsOptional()
  public id?: string;

  @IsEnum(AddressTypeEnum)
  public type: AddressTypeEnum;

  @Length(2, 64)
  public firstName: string;

  @Length(2, 128)
  public lastName: string;

  @IsOptional()
  @Length(9, 12)
  @Matches(phoneRegexp)
  @IsMobilePhone()
  public phone?: string;

  @IsOptional()
  @Length(2, 128)
  @IsEmail()
  public email?: string;

  @IsOptional()
  @Length(2, 128)
  public companyName?: string;

  @IsOptional()
  @Length(2, 16)
  public taxId?: string;

  @Length(32, 36)
  public locationId: string;
}
